import {
  DueOutFetchArgs,
  getDueOutDistinctValues,
} from '../../assets/ts/data/dueout/dueout'
import useServerData from '../use-server-data'

function useDueOutDistinctValues(
  fetchArgs: DueOutFetchArgs,
  waitOnParentDependency = false
) {
  const {
    data: dueOutDistinctValues,
    error: dueOutDistinctValuesError,
    fetchData: fetchDueOutDistinctValues,
    isLoading: dueOutDistinctValuesAreLoading,
  } = useServerData<Map<string, number[] | string[]>, DueOutFetchArgs>(
    getDueOutDistinctValues,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    dueOutDistinctValues,
    dueOutDistinctValuesAreLoading,
    dueOutDistinctValuesError,
    fetchDueOutDistinctValues,
  }
}

export default useDueOutDistinctValues
